<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">
            <!-- Filtros de Dealers -->
            <div class="filtro-dash">
              <div>
                <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                  {{'relatorioVeiculos.veiculoRegional.dealers'}}
                </div>
                <span class="btn btn-outline-info btn-sm" *ngFor="let dealer of filtrosDealers.selecionados()"
                  style="margin: 6px 2px 0px 2px; text-transform: uppercase;" (click)="removerDealer(dealer)">
                  {{dealer.nome}}
                  <i class="fa fa-times" aria-hidden="true" (click)="removerDealer(dealer)"></i>
                </span>
                <div class="botao">
                  <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
                    <em class="fa fa-plus"></em>
                  </button>
                </div>
                <div class="clear"></div>
              </div>
            </div>
            <hr>
            <!-- Controles de Data e Filtros -->
            <div class="row ptb20">
              <div class="col col-3">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'businessIntelligence.retencaoVeiculo.periodo'}}
                </div>
                <p-calendar [(ngModel)]="dataInicial" dateFormat="mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [yearNavigator]="true"
                  (onClearClick)="limpaDataInicial()" [monthNavigator]="true" yearRange="2000:2030"
                  placeholder="{{'businessIntelligence.retencaoVeiculo.periodoPlaceHolder' | translate}}"
                  showButtonBar="true" view="month">
                </p-calendar>
              </div>
              <div class="col col-lg-9 col-md-12 mt-3">
                <div class="d-flex align-items-end justify-content-between flex-wrap">
                  <div class="d-flex flex-wrap">
                    <button translate type="button" class="btn btn-primary mr-2 mb-2" (click)="filtroAPI()">
                      {{'relatorioVeiculos.veiculoRegional.filtrar' | translate}}
                      <i class="fas fa-search ml-1"></i>
                    </button>
                    <button [class.btn-info]="!getListagemComFiltros()" [class.btn-warning]="getListagemComFiltros()"
                      translate class="btn mr-2 mb-2" type="button" (click)="exibirFiltro()">
                      {{'relatorioVeiculos.veiculoRegional.maisFiltros' | translate}}
                      <em class="fa fa-filter ml-1"></em>
                    </button>
                  </div>
                  <div class="d-flex">
                    <button pButton class="p-button-outlined p-button-secondary p-button-sm mb-2" type="button"
                      (click)="exportExcel()">
                      <i class="fa fa-download mr-1"></i>Export Excel
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <hr>

            <p-table [value]="salesAgrupado" class="custom-table"
              styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm style p-datatable-sticky-header">
              <!-- HEADER -->
              <ng-template pTemplate="header">
                <tr>
                  <th class="header-dealer">Dealer</th>
                  <th *ngFor="let fam of familiasColunas" class="p-text-center">
                    {{ fam }}
                  </th>
                </tr>
              </ng-template>
              <!-- BODY -->
              <ng-template pTemplate="body" let-row>
                <tr *ngIf="!row.isTotal && expandedRegions[row.regiao]">
                  <td>{{ row.name }}</td>
                  <td *ngFor="let fam of familiasColunas" class="p-text-center">
                    <a class="link" (click)="abrirModal(row, fam)">{{ row.familiasMap[fam] || 0 }}</a>
                  </td>
                </tr>
                <tr *ngIf="row.isTotal" class="linha-total-regiao" (click)="toggle(row.regiao, $event)"
                  style="cursor: pointer;">
                  <td class="p-text-left">
                    <i [class]="dropdawn" (click)="toggle(row.regiao, $event)" class="region-toggle-icon"
                      title="Expandir/Recolher região" role="button"></i>
                    TOTAL - {{ row.regiao }}
                  </td>
                  <td *ngFor="let fam of familiasColunas" class="p-text-center">
                    {{ row.familiasMap[fam] || 0 }}
                  </td>
                </tr>
              </ng-template>
            </p-table>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-filtro-dealers [(visible)]="displayFiltrosDealers" [dealers]="filtrosDealers.dealers"
  [headerTitle]="'relatorioVeiculos.controleProposta.selecioneDealers'"
  [filterPlaceholder]="'relatorioVeiculos.controlePedidos.filtrarDealers'"
  (dealerSelected)="onAdicionarDealerFiltro($event)">
</app-filtro-dealers>


<!-- Dialog de Filtros -->
<p-dialog header="Definir filtros" [(visible)]="displayFiltros" [style]="{width: '550px'}" [modal]="true"
  [draggable]="false">
  <form [formGroup]="form">
    <div class="container striped-rows">
      <div class="row mb-3">
        <div translate class="col col-4">
          {{'relatorioVeiculos.veiculoRegional.filtros.regional' | translate}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body"
            placeholder="{{'relatorioVeiculos.veiculoRegional.filtros.regionalPlaceHolder' | translate}}"
            [options]="regiao" optionLabel="nome" optionValue="valor" formControlName="id_regiao"
            [autoDisplayFirst]="false" [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
          </p-dropdown>
        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-outline-primary" (click)="limparFiltros()">
      <i class="fa fa-trash" aria-hidden="true"></i>
    </button>
    <button translate type="button" class="btn btn-info"
      (click)="filtroAPI()">{{'relatorioVeiculos.veiculoRegional.filtrar'}}</button>
  </ng-template>
</p-dialog>


<p-dialog header="Modelos" [(visible)]="gridModelos" [style]="{width: '1000px'}" [modal]="true" [draggable]="false">
  <div>
    <p-table [value]="dadosModelos"
        styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines">

      <!-- HEADER -->
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of cols"
              class="text-center"
              style="background-color:black;color:white;">
            {{ col.header }}
          </th>

          <th class="text-center" style="background-color:black;color:white;">
            Editar
          </th>
        </tr>
      </ng-template>

      <!-- BODY -->
      <ng-template pTemplate="body" let-row>
        <tr>
          <td *ngFor="let col of cols" class="text-center">

            <!-- SOMENTE QUANTIDADE PRODUÇÃO É EDITÁVEL -->
            <ng-container *ngIf="col.field === 'quantidadeProducao'; else leitura">
              <ng-container *ngIf="row.editando; else valor">
                <input type="number"
                      class="form-control form-control-sm text-center"
                      [(ngModel)]="row.quantidadeProducao"
                      min="0"
                      (ngModelChange)="validarQuantidade(row)">
              </ng-container>
            </ng-container>

            <!-- EXIBIÇÃO PADRÃO -->
            <ng-template #valor>
              {{ row[col.field] }}
            </ng-template>

            <ng-template #leitura>
              {{ row[col.field] }}
            </ng-template>

          </td>

          <!-- AÇÃO -->
          <td class="text-center">
            <button class="btn btn-sm btn-info"
                    *ngIf="!row.editando"
                    (click)="editarLinha(row)">
              <i class="pi pi-pencil"></i>
            </button>

            <button class="btn btn-sm btn-success"
                    *ngIf="row.editando"
                    (click)="confirmarLinha(row)">
              <i class="pi pi-check"></i>
            </button>
          </td>
        </tr>
      </ng-template>

    </p-table>

  </div>
  <ng-template pTemplate="footer">
  <button type="button"
          class="btn btn-outline-primary"
          (click)="gridModelos=false">
    <i class="fa fa-times"></i>
    Fechar
  </button>

  <button type="button"
          class="btn btn-success"
          [disabled]="salvando"
          (click)="salvar()">
    <i class="pi pi-check"></i>
    Salvar
  </button>
</ng-template>
</p-dialog>